import { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import WhiteListing from "components/WhiteListing";
import Airdrop from "components/Airdrop";
import WhiteListNFT from "components/WhiteListNFT";

import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Redirect,
} from "react-router-dom";
import Chains from "components/Chains";
// import ResponsiveAntMenu from 'responsive-ant-menu';
import NFTBalance from "components/NFTBalance";
import NFTTokenIds from "components/NFTTokenIds";
import Homepage from "pages/Homepage";
import NFTDetails from "components/NFTDetails";
import { Menu, Layout, Button, Input } from "antd";
import SearchCollections from "components/SearchCollections";
import "antd/dist/antd.css";
import NativeBalance from "components/NativeBalance";
import "./style.css";
import Logo from "images/HeaderLogo.png";
import Text from "antd/lib/typography/Text";
import NFTMarketTransactions from "components/NFTMarketTransactions";
const { Header, Footer } = Layout;

const styles = {
  content: {
    display: "flex",
    justifyContent: "center",
    fontFamily: "Roboto, sans-serif",
    color: "#041836",
    padding: "250px",
    background: "#000",
  },
  header: {
    zIndex: 1,
    width: "100%",
    height: "106px",
    background: "#000",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto, sans-serif",
    borderBottom: "2px solid rgba(0, 0, 0, 0.06)",
    padding: "0 65px",
    boxShadow: "0 1px 10px rgb(151 164 175 / 10%)",
  },
  headerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
  },
};
const App = ({ isServerInfo }) => {
  const { isWeb3Enabled, enableWeb3, isAuthenticated, isWeb3EnableLoading } =
    useMoralis();
  const {
    marketAddress,
    contractABI,
    marketAddressPass,
    contractABIPass,
    walletAddress,
  } = useMoralisDapp();
  const contractABIJson = JSON.parse(contractABI);
  const contractABIPassJson = JSON.parse(contractABIPass);
  const { Moralis } = useMoralis();
  const [inputValue, setInputValue] = useState("explore");
  const [showMenu, setShowMenu] = useState(false);
  const [showMenuPass, setShowMenuPass] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading) enableWeb3();
    getOwner();
    getOwnerPass();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isWeb3Enabled]);

  async function getOwner() {
    const ops = {
      contractAddress: marketAddress,
      functionName: "owner",
      abi: contractABIJson,
    };
    try {
      const res = await Moralis.executeFunction(ops);
      console.log("result", res);
      console.log("wallet", walletAddress);
      if (res.toUpperCase() === walletAddress.toUpperCase()) {
        setShowMenu(true);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function getOwnerPass() {
    const ops = {
      contractAddress: marketAddressPass,
      functionName: "owner",
      abi: contractABIPassJson,
    };
    try {
      const res = await Moralis.executeFunction(ops);
      console.log("wallet", walletAddress);
      if (res.toUpperCase() === walletAddress.toUpperCase()) {
        setShowMenuPass(true);
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Layout style={{ height: "100vh", overflow: "auto" }}>
      <Router>
        <Navbar
          collapseOnSelect
          expand="lg"
          variant="dark"
          className="py-4 px-5"
        >
          <Container className="mw-100">
            <Navbar.Brand href="https://www.web3tx.org/">
              <img src={Logo} alt="Web3 Texas"></img>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="text-center m-auto d-none d-lg-block d-xl-block">
                <h1 className="text-white">NFT Marketplace</h1>
              </Nav>
              <Nav>
                <Nav>
                  <Nav.Link className="m-auto">
                    <NavLink
                      to="/nft-store"
                      key="nftMarket"
                      onClick={() => setInputValue("explore")}
                      className="text-white m-xl-auto"
                    >
                      Go to Home
                    </NavLink>
                  </Nav.Link>
                  {showMenu === true && (
                    <Nav.Link className="m-auto">
                      <NavLink
                        to="/whiteList"
                        key="whiteList"
                        className="text-white m-xl-auto"
                      >
                        WhiteList
                      </NavLink>
                    </Nav.Link>
                  )}
                  {showMenuPass === true && (
                    <Nav.Link className="m-auto">
                      <NavLink
                        to="/whiteListNFT"
                        key="whiteListNFT"
                        className="text-white m-xl-auto"
                      >
                        WhiteList NFT
                      </NavLink>
                    </Nav.Link>
                  )}
                  {showMenuPass === true && (
                    <Nav.Link className="m-auto">
                      <NavLink
                        to="/airdrop"
                        key="airdrop"
                        className="text-white m-xl-auto"
                      >
                        Airdrop
                      </NavLink>
                    </Nav.Link>
                  )}
                </Nav>
                <Nav.Link
                  href="#"
                  onClick={(event) =>
                    (window.location.href =
                      "https://www.web3tx.org/#contact-us")
                  }
                >
                  <Button className="contact-button border-button text-white">
                    CONTACT US
                  </Button>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div>
          <Switch>
            <Route path="/nftBalance">
              <NFTBalance />
            </Route>
            <Route path="/NFTMarketPlace">
              <NFTTokenIds
                inputValue={inputValue}
                setInputValue={setInputValue}
              />
            </Route>
            <Route path="/Transactions">
              <NFTMarketTransactions />
            </Route>
            <Route path="/whiteList">
              <WhiteListing />
            </Route>
            <Route path="/whiteListNFT">
              <WhiteListNFT />
            </Route>
            <Route path="/airdrop">
              <Airdrop />
            </Route>
            {/* <Route path="/nftDetails">
              <NFTDetails />
            </Route> */}
            <Route
              path="/nftDetail"
              render={(props) => <NFTDetails {...props} />}
            />
            <Route path="/nft-store">
              <Homepage />
            </Route>
          </Switch>
          <Redirect to="/nft-store" />
        </div>
      </Router>
      <Footer>
        <img src={Logo} alt="Web3 Texas"></img>
        <p className="pass-desc mt-4 mb-5">
          Web3 Texas is the Genesis Block and D.B.A. subsidiary to Web3 Earth,
          Inc.
          <br />
          ©2022 Web3 Earth, Inc. is a non-profit organization with a 501(c)(3)
          tax-exempt status.
          <br />
          All rights reserved.
        </p>
        <hr className="opacity-75"></hr>
        <span className="pass-desc">
          Copyright © Web3 Texas 2022 | Designed with <HeartFilled /> at
          Reveation Labs
        </span>
      </Footer>
    </Layout>
  );
};

export const HeartFilled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4.5C14.9 4.5 13.05 5.55 12 7.2C10.95 5.55 9.1 4.5 7 4.5C3.7 4.5 1 7.2 1 10.5C1 16.45 12 22.5 12 22.5C12 22.5 23 16.5 23 10.5C23 7.2 20.3 4.5 17 4.5Z"
      fill="#F44336"
    />
  </svg>
);

export default App;
